import React from 'react'
import {useCartContext} from '../context/CartContext';
import storeItems from "../data/StoreData.json";
import FormatCurrency from './FormatCurrency';
import {Link} from 'react-router-dom';

const RowInCart = ({id}) => {
    const {CartItems, removeFromCart, getItemQuantity} = useCartContext();

  const item = storeItems.find((i) => i.id === id);
   if (item == null) return null;
    
  return (

  <tr>
    <td> <Link to={`/Product_details/${id}` }><img src={item.imgUrl} alt='sora' /></Link></td>
    <td> <h2>  {item.title}  </h2> </td>
    <td> <span> {FormatCurrency(item.price)}  </span> </td>
    <td> <span> {getItemQuantity(item.id)} </span> </td>          
    <td> <span> {FormatCurrency(item.price * getItemQuantity(item.id))} </span> </td>          

    <td> <button onClick={()=>removeFromCart(item.id)} className=" btn btn-danger "><i className="fa-solid fa-xmark"></i></button> </td>

</tr>    
      
  )
}

export default RowInCart